module.exports = __webpack_public_path__ + "img/icon_e67.3291054c.png";